import axios from '@/app/plugins/Axios'

export default new class RepresentantesService {

  listar() {
    return axios.get('representantes')
        .then(response => response.data);
  }

  abrir(id) {
    return axios.get('/representantes/' + id)
        .then(response => response.data);
  }

  salvar(representante) {
    return axios.post('/representantes', representante)
        .then(response => response.data);
  }

  atualizar(representante) {
    return axios.put('/representantes/' + representante.id, representante)
        .then(response => response.data);
  }

  excluir(id) {
    return axios.delete('/representantes/' + id)
        .then(response => response.data);
  }
}
